import React, { Fragment } from 'react'
import { PeopleQuery, StateProvider, getHTML, getRichText } from '../../core'

import './team.scss'

const PersonComponent = (person) => {
  if (!person) {
    return null
  }

  const resize = person.photo ? person.photo.resize : {}

  return (
    <StateProvider>{(isActive, setActive) => {
      const onClick = () => {
        if (window.DEACTIVATE_BIO) {
          window.DEACTIVATE_BIO()
        }

        setActive(!isActive)
        window.DEACTIVATE_BIO = (e) => {
          setActive(false)
        }
      }

      return (
        <div styleName="person" data-is-active={isActive} onClick={onClick}>
          <div 
            styleName="photo"
            style={{ backgroundImage: `url(${resize.src})`}}
          />

          <div styleName="caption">
            <h4>{person.firstName} {person.lastName}</h4>
            <h5 styleName="role">{person.role}</h5>
          </div>
  
          <div styleName="bio-wrapper">
            <div styleName="bio original">
              <div styleName="inner">
                {getRichText(person.editableContent)}
              </div>
            </div>
            <div styleName="bio copy">
              <div styleName="inner">
                {getRichText(person.editableContent)}
              </div>
            </div>
          </div>
        </div>
      )
    }}</StateProvider>
  )
}

const TeamSection = ({ data = {}, context = {} }) => {
  let { 
    title,
    people,
  } = context

  title = title || 'Meet The'

  const {
    isRandom,
  } = data

  if (!people) {
    return (
      <section styleName="team show-all">
        <h3>Meet the Team</h3>
        <PeopleQuery
          render={({ data }) => {
            const allPeople = data.people || []

            const execs = allPeople.filter(p => p.isExec)
            const peons = allPeople.filter(p => !p.isExec)
            
            return (
              <Fragment>
                <div styleName="exec-team people">
                  {execs.map((person, i) => (
                    <PersonComponent {...person} key={i} />
                  ))}
                </div>
              
                <div styleName="rest-of-team people">
                  {peons.map((person, i) => (
                    <PersonComponent {...person} key={i} />
                  ))}
                </div>
              </Fragment>
            )
          }}
        />
      </section>
    )
  }

  const renderPeople = (people || []).map((person, i) => (
    <PersonComponent {...person} key={i} />
  ))
    
  const style = people && people.length > 2 
    ? "rest-of-team people no-select"
    : "people no-select"

  return (
    <section styleName="team show-all">
      <h5><b>{title} Team</b></h5>
      <div styleName={`${style}`}>
        {renderPeople}
      </div>

      <a href="/about-us">
        <button>Meet the Bond Team</button>
      </a>
    </section>
  )

}

export default TeamSection